export default __webpack_public_path__ + "static/media/show10.30e97bec.jpeg";